"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routeMatchToAction = exports.RouteAction = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_router_dom_2 = require("react-router-dom");
/**
 * Types
 */
var RouteAction;
(function (RouteAction) {
    RouteAction[RouteAction["RENDER_COMPONENT"] = 0] = "RENDER_COMPONENT";
    RouteAction[RouteAction["REDIRECT"] = 1] = "REDIRECT";
    RouteAction[RouteAction["REDIRECT_EXTERNAL"] = 2] = "REDIRECT_EXTERNAL";
    RouteAction[RouteAction["RENDER_COMPONENT_WITH_LOADER"] = 3] = "RENDER_COMPONENT_WITH_LOADER";
})(RouteAction = exports.RouteAction || (exports.RouteAction = {}));
/**
 * Called when a route has been matched by React Router. Decides on an action based on the routeDefinition
 * configuration (i.e redirect or render a component, see TRouteAction)
 *
 * @internal
 * @param params          The params object from react router
 * @param location        The window location
 * @param routeDefinition The route definition that was matched
 * @param context         The context that the routing config was set up with
 */
const routeMatchToAction = ({ params, routeDefinition, location, context, }) => {
    if (routeDefinition.documentTitle !== undefined) {
        document.title =
            typeof routeDefinition.documentTitle === "string"
                ? routeDefinition.documentTitle
                : routeDefinition.documentTitle({ location, params, context });
    }
    if (routeDefinition.interceptors !== undefined) {
        for (const interceptor of routeDefinition.interceptors) {
            const action = interceptor({ routeDefinition, params, location, context });
            if (action != null) {
                return action;
            }
        }
    }
    if (routeDefinition.component !== undefined && routeDefinition.loader !== undefined) {
        return {
            kind: RouteAction.RENDER_COMPONENT_WITH_LOADER,
            component: routeDefinition.component,
            loader: routeDefinition.loader,
        };
    }
    if (routeDefinition.component !== undefined) {
        return { kind: RouteAction.RENDER_COMPONENT, component: routeDefinition.component };
    }
    // Should never happen if we validate route config, just a guard against programming errors
    throw new Error("Route is not properly configured! " + JSON.stringify(routeDefinition));
};
exports.routeMatchToAction = routeMatchToAction;
/**
 * @category Component
 */
const RouteInterceptor = ({ context, routeDefinition }) => {
    const location = window.location;
    const params = (0, react_router_dom_1.useParams)();
    const action = (0, exports.routeMatchToAction)({ routeDefinition, params, location, context });
    if (action.kind === RouteAction.RENDER_COMPONENT_WITH_LOADER) {
        return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(action.loader, null) },
            react_1.default.createElement(action.component, null)));
    }
    else if (action.kind === RouteAction.RENDER_COMPONENT) {
        return react_1.default.createElement(action.component, null);
    }
    else if (action.kind === RouteAction.REDIRECT) {
        const { kind, ...navigateProps } = action;
        return react_1.default.createElement(react_router_dom_2.Navigate, { replace: true, ...navigateProps });
    }
    else if (action.kind === RouteAction.REDIRECT_EXTERNAL) {
        window.location.replace(String(action.to));
        return null;
    }
    else {
        throw new Error("Unknown action! " + JSON.stringify(routeDefinition));
    }
};
exports.default = RouteInterceptor;
